export default "__VITE_ASSET__ChnwpM86__"